module.exports = __webpack_public_path__ + "static/fresno-be96006a831039fdeaabf710ba374856.png";